import { toDollars } from "common/utils/formatting";
import { SummaryShippingRate } from "common/types/shipping";

import styles from "../../common/styles/ShippingRate.module.less";

type ShippingRateProps = {
  shippingRates: SummaryShippingRate[];
  title: string;
};

const ShippingRate = (props: ShippingRateProps) => {
  const { shippingRates, title } = props;

  return (
    <>
      <h3 className={styles.header}>{title}</h3>
      <div className={styles.rates}>
        {shippingRates.map((rate) => (
          <div className={styles.rate} key={rate.display}>
            <div className={styles.point}>
              <div className={styles.value}>{rate.display}</div>
            </div>
            {rate.free_shipping_over ? (
              <>
                <div className={styles.point}>
                  <div className={styles.value}>
                    {rate.is_eligible_for_free_over ? "FREE!" : toDollars(rate.cost)}
                  </div>
                  <div className={styles.label}>
                    Orders over {toDollars(rate.free_shipping_over, { roundCents: true })}
                  </div>
                </div>
                <div className={styles.point}>
                  <div className={styles.value}>{toDollars(rate.cost)}</div>
                  <div className={styles.label}>
                    Orders below {toDollars(rate.free_shipping_over, { roundCents: true })}
                  </div>
                </div>
              </>
            ) : (
              <div className={styles.bigPoint}>{toDollars(rate.cost)}</div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ShippingRate;
